let inject = ['$scope', '$uibModalInstance','modalOptions', '$timeout'];

class ModalMapController {
  constructor ($scope,$uibModalInstance,modalOptions, $timeout) {
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.activateMap = false;
    this.$uibModalInstance = $uibModalInstance;
    this.map = Object.assign({}, modalOptions);
    if(angular.isString(this.map.center.latitude)) this.map.center.latitude = parseFloat(this.map.center.latitude);
    if(angular.isString(this.map.center.longitude)) this.map.center.longitude = parseFloat(this.map.center.longitude);
    this.map.marker = {
      id : 0,
      latitude : this.map.center.latitude,
      longitude : this.map.center.longitude,
      title : "m0",
    };
    this.$timeout(() => {
      this.activate();
    }, 1000);
  }

  activate(){
    this.activateMap = true;
    this.$timeout(() => {
      this.activateMap = false;
    }, 1000);
  }

  refresh(){
    this.activateMap = true;
    this.$timeout(() => {
      this.activateMap = false;
    }, 1000);
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  ok() {
    this.$uibModalInstance.close();
  }
}

ModalMapController.$inject = inject;

export default ModalMapController;



/** WEBPACK FOOTER **
 ** C:/Bitnami/wampstack-7.1.31-0/apache2/htdocs/toning/B2C/www/components/shared/components/modal-map/modal-map.controller.js
 **/